(function($) {
    var $supapressJQuery = jQuery.noConflict(),
        $body = $supapressJQuery('body'),
        $widgetEditModuleLink = $supapressJQuery('.widget-control-module-edit');

    // delegate event to body so persists when DOM element added or destroyed through interface
    $body.on('click', '.widget-control-module-edit', function() {
        var $this = $(this),
            val = $this.parent().find('select').val();
        if (val) {
            window.location = $widgetEditModuleLink.data("adminUrl") + '&post=' + val + '&action=edit';
        } else {
            alert ('Please choose a module to edit.');
        }
    });
})(jQuery);

